import { render, staticRenderFns } from "./class.vue?vue&type=template&id=30475c30&"
import script from "./class.vue?vue&type=script&lang=js&"
export * from "./class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports